import { z } from 'zod/v3';
import { AlgorithmMappingValidFormDataSchema } from './AlgorithmMappingValidFormDataSchema';

export const AlgorithmMappingsValidFormDataSchema = z.object({
  mappings: z.array(AlgorithmMappingValidFormDataSchema),
});
